import styled from "styled-components";

const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  width: 100%;
  cursor: ${(props) => props.disabled ? "unset" : "move"} ;
  user-select: none;
`;

export default Container;

